import { ChoicesOrderStatus } from '@/types/order';
import { ChoicesStatusMilestone } from '@/types/milestone.interface';
import { CANCELLABLE_ORDER_STATUSES } from '../contants/cancel-order-constants';
import { AuthUserType } from '@auth/types';

export const checkCanCancelOrder = (
  user: AuthUserType | undefined,
  orderStatus: ChoicesOrderStatus
): boolean => {
  if (!user) {
    return false;
  }

  return user?.isAdmin && user?.isStaff && CANCELLABLE_ORDER_STATUSES.includes(orderStatus);
};

export function isMilestoneDisabled(status: string): boolean {
  return status === ChoicesStatusMilestone.CANCELLED || status === ChoicesStatusMilestone.REVERSED;
}
